import { render } from "./PedidoDetalhe.vue?vue&type=template&id=524f6cf1&scoped=true"
import script from "./PedidoDetalhe.vue?vue&type=script&lang=js"
export * from "./PedidoDetalhe.vue?vue&type=script&lang=js"

import "./PedidoDetalhe.vue?vue&type=style&index=0&id=524f6cf1&scoped=true&lang=scss"

import exportComponent from "/Users/rogeriolugaoveltem/Documents/mtex_nesher_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524f6cf1"]])

export default __exports__